var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _ellipse, _path9, _path10, _path11, _rect, _path12, _ellipse2, _path13, _path14, _path15, _rect2, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallCenterFlat51145(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M413.27,427.24v16.83H87.34c-8-76.87,63.71-123.76,133.9-123.58,36.24.4,87.13-3.67,120.46,12.46C380,348.54,413.6,384.06,413.27,427.24Z",
    fill: "#0099f5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M413.27,427.24c.33-43.18-33.27-78.7-71.57-94.29-33.33-16.13-84.22-12.06-120.46-12.46a159.92,159.92,0,0,0-63.49,13,159,159,0,0,1,16-.8c36.25.39,87.13-3.68,120.46,12.45,38.3,15.6,71.9,51.12,71.58,94.3v4.65h47.45Z",
    opacity: 0.09,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.94,375.68l-32.53,19.74a3.91,3.91,0,0,1-5.4-1.37L173.84,333.7a3.91,3.91,0,0,1,1.56-5.43l32.38-16.95a3.89,3.89,0,0,1,5.14,1.41l35.33,57.57A3.9,3.9,0,0,1,246.94,375.68Z",
    opacity: 0.09,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.69,375.68l32.54,19.74a3.91,3.91,0,0,0,5.4-1.37L326.8,333.7a3.91,3.91,0,0,0-1.57-5.43l-32.37-16.95a3.89,3.89,0,0,0-5.14,1.41L252.39,370.3A3.91,3.91,0,0,0,253.69,375.68Z",
    opacity: 0.09,
    style: {
      isolation: "isolate"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M280.54,371.5l-30.22-11.09h0L220.09,371.5,241,408.33l-7.84,35.72h34.31l-7.84-35.72Z",
    fill: "#24285b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M250.32,366.07a36,36,0,0,1-36-36V234.34c.8-47.29,71.21-47.34,72,0v95.72A36,36,0,0,1,250.32,366.07Z",
    fill: "#ffbeb3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M284.58,341.12c-10.22,33.08-58.62,32.68-68.55,0C230.6,362,269.41,362.77,284.58,341.12Z",
    fill: "#f9a498"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M247.24,367.93,217.43,386a3.58,3.58,0,0,1-5-1.26l-32.23-55.29a3.59,3.59,0,0,1,1.44-5L211.35,309a3.58,3.58,0,0,1,4.71,1.3L248.44,363A3.58,3.58,0,0,1,247.24,367.93Z",
    fill: "#0099f5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M253.42,367.93,283.24,386a3.58,3.58,0,0,0,4.95-1.26l32.22-55.29a3.58,3.58,0,0,0-1.43-5L289.32,309a3.6,3.6,0,0,0-4.72,1.3L252.23,363A3.58,3.58,0,0,0,253.42,367.93Z",
    fill: "#0099f5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M178.65,199c-1.69-8.53-9.81-16.47-21-14s-11.17,12.83-9.48,21.37c.1.44,5.57,23.52,8.8,28.37s7.89,14.09,15.72,11.46c5.18-1.74,8.23-11,9.46-17.62S178.65,199,178.65,199Z",
    fill: "#ffbeb3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M320.46,198.63c1.69-8.54,9.81-16.48,21-14s12.23,13.13,10.54,21.66c-.09.45-6,21.81-8.79,28.38-2.29,5.42-8.51,15-16.6,11.62-5.06-2.09-8.42-11.43-9.65-18.09S320.46,198.63,320.46,198.63Z",
    fill: "#ffbeb3"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 137.39,
    cy: 215.94,
    rx: 11.36,
    ry: 23.56,
    transform: "translate(-22.19 15.84) rotate(-6.11)",
    fill: "#ffd44d"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M134.88,192.51c.24,0,.49,0,.73,0A5.94,5.94,0,0,0,134.88,192.51Z",
    fill: "#ffd44d"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M138.37,225.09c-5.56.6-10.79-4.69-12.55-12.21,0,1.39.11,2.82.27,4.27,1.38,12.94,7.56,22.88,13.8,22.22s10.18-11.7,8.8-24.64c-.16-1.45-.38-2.86-.64-4.22C147.91,218.22,143.92,224.5,138.37,225.09Z",
    fill: "#f9bb0d"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M134.88,192.51a5.55,5.55,0,0,0-.71.13C134.4,192.59,134.64,192.54,134.88,192.51Z",
    fill: "#ffd44d"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 137.44,
    y: 180.04,
    width: 34.99,
    height: 71,
    rx: 10.12,
    transform: "translate(-22.05 17.7) rotate(-6.11)",
    fill: "#0099f5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M161.46,179.58c0,.26.1.52.13.78l5.4,50.47A10.12,10.12,0,0,1,158,242l-14.66,1.57a10.12,10.12,0,0,1-3-.12,10.11,10.11,0,0,0,11,8.2L166,250.06a10.13,10.13,0,0,0,9-11.15l-5.39-50.46A10.14,10.14,0,0,0,161.46,179.58Z",
    fill: "#0086f4"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 362.61,
    cy: 215.94,
    rx: 23.56,
    ry: 11.36,
    transform: "translate(109.33 553.53) rotate(-83.89)",
    fill: "#ffd44d"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M365.12,192.51c-.24,0-.49,0-.73,0A5.94,5.94,0,0,1,365.12,192.51Z",
    fill: "#ffd44d"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M361.63,225.09c5.56.6,10.79-4.69,12.55-12.21,0,1.39-.11,2.82-.27,4.27-1.38,12.94-7.56,22.88-13.8,22.22s-10.18-11.7-8.8-24.64c.16-1.45.38-2.86.64-4.22C352.09,218.22,356.08,224.5,361.63,225.09Z",
    fill: "#f9bb0d"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M365.12,192.51a5.55,5.55,0,0,1,.71.13C365.6,192.59,365.36,192.54,365.12,192.51Z",
    fill: "#ffd44d"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 327.57,
    y: 180.04,
    width: 34.99,
    height: 71,
    rx: 10.12,
    transform: "translate(665.24 466.56) rotate(-173.89)",
    fill: "#0099f5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M338.54,179.58c-.05.26-.1.52-.13.78L333,230.83A10.12,10.12,0,0,0,342,242l14.66,1.57a10.12,10.12,0,0,0,3-.12,10.11,10.11,0,0,1-11,8.2L334,250.06a10.13,10.13,0,0,1-9-11.15l5.39-50.46A10.14,10.14,0,0,1,338.54,179.58Z",
    fill: "#0086f4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M331.34,134.78c0-37-22.94-74.18-83.67-74.18s-82.78,40.66-82.78,77.68c0,1.95-.18,102.63,11.61,125.75s44.25,46.7,73.23,46.81c31.7.13,60.19-20.24,73.5-46.81S331.34,134.78,331.34,134.78Z",
    fill: "#ffbeb3"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M188.26,143.11l1.6,1.14c1.66,1.57-6.68,20.16-4.25,20.25,12,2.53,26.46-23.52,38.22-19.87,20.69,6.44,59.61,58.59,97.8,57.57,10-9.68,9.71-67.42,9.71-67.42,0-37-22.94-74.18-83.67-74.18-50.31,0-74,27.92-80.69,58.54C176.37,123.16,184.24,130.92,188.26,143.11Z",
    fill: "#f9a498"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M320.49,268.92c.13-.21.29-.4.41-.61-.68.49-1.39.94-2.09,1.42C319.38,269.48,319.93,269.18,320.49,268.92Z",
    fill: "#efe8e4",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M263.49,303c-29-.11-61.44-23.7-73.23-46.82s-11.61-123.79-11.61-125.74c0-16.59,4.62-33.79,15-47.83a77.94,77.94,0,0,1,3.81-8.89c-23.16,15-32.56,40.48-32.56,64.53,0,1.95-.18,102.63,11.61,125.75s44.25,46.7,73.23,46.81c16.44.07,31.92-5.51,45-14.48A76.57,76.57,0,0,1,263.49,303Z",
    fill: "#f9a498"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M344.92,126c-7.47-40.76-40.76-70.32-95.19-70-54.27.34-89.93,33.6-97.07,71.33-3,16.16-5.74,34.9-4.49,53.21,14.59-2,13.31,3.44,17.76,5.21,3,33.3,10.29,32.8,10.29,32.8s.66-22.61,2.14-37.56,25.94-17.65,38.17-43.48c38.72-1.68,63.17,47.91,105.63,50.63-4.2,24.54,5.1,34.31,5.1,34.31s1-20.28,4.41-29.9c3-8.38,12.46-15.72,16.86-12.09C350.64,165.18,349.05,148.47,344.92,126Z",
    fill: "#9c5631"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M344.92,126c-7.47-40.76-40.76-70.32-95.19-70-47.63.3-80.92,26-93.17,57.75C171.82,87.58,202.43,68,244,67.69c54.43-.33,87.72,29.21,95.19,70,3,16.55,4.94,28.12,4.6,42.23,1.77.33,3.44-.51,4.71.53C350.64,165.18,349.05,148.47,344.92,126Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    style: {
      mixBlendMode: "multiply"
    }
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M216.53,118.11c-12.23,25.84-51.64,50.18-68,55-.05-.83-.07-1.82-.11-2.71-.3,8.08-.64,3.84-.22,10.1,9.19-7.56,10.44-2,14.89-.28,3.05,33.29,13.16,38.29,13.16,38.29s.66-22.61,2.14-37.56,25.94-17.65,38.17-43.48c38.55-1.68,63,47.45,105.1,50.55C290.57,177.25,255.25,116.43,216.53,118.11Z",
    fill: "#afaaa8"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M142.81,181.19a8.83,8.83,0,0,1,1-.16l12-1.29c0-.51-.07-1-.1-1.51-.29-5.33-.73-10.59-.75-15.88a92.89,92.89,0,0,1,3.53-25.14C169.57,97,208.32,68.42,250,69.61c41.68-1.2,80.43,27.4,91.49,67.6A92.89,92.89,0,0,1,345,162.35c0,5.29-.46,10.55-.75,15.88,0,.49-.07,1-.1,1.51l12,1.29a8.83,8.83,0,0,1,1,.16c.05-.92.1-1.67.14-2.19.31-5.5.79-11.11.82-16.68a106.08,106.08,0,0,0-3.94-28.72C341.73,87.66,297.57,54.85,250,56c-47.57-1.12-91.73,31.7-104.21,77.64a106.08,106.08,0,0,0-3.94,28.72c0,5.57.5,11.18.82,16.68C142.71,179.51,142.75,180.26,142.81,181.19Z",
    fill: "#24285b"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M337.7,250.46l-1.21,6.45a15.63,15.63,0,0,1-15.35,12.73H279.55c-2.44-2.24-6.62-3.71-11.37-3.71-7.54,0-13.65,3.7-13.65,8.26s6.11,8.27,13.65,8.27c4.83,0,9.07-1.53,11.49-3.82h41.47a24.63,24.63,0,0,0,24.19-20.06l1.35-7.14Z",
    fill: "#24285b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallCenterFlat51145);
export default __webpack_public_path__ + "static/media/call-center-flat-51145.5c4d0984283d2585081873935ca79297.svg";
export { ForwardRef as ReactComponent };